import React from 'react';
import { Link } from 'react-router-dom';
import { PageFooter } from 'adc-ui-components';

import {
  HOME,
  SWAPS,
  SWAPS_NEW,
} from '../../../helpers/routes';

const LegacyFooter = ({
  component: Component,
  isHarness,
  device,
  ...props
}) => (
  <>
    <PageFooter showCPPFooter />
    {(process.env.NODE_ENV !== 'production') && (
    <ul
      style={{
        position: 'fixed',
        left: '0',
        bottom: '0',
        zIndex: '10',
      }}
    >
      <li><Link to={HOME}>Home</Link></li>
      <li><Link to={SWAPS}>Swaps</Link></li>
      <li><Link to={SWAPS_NEW}>New Swap</Link></li>
    </ul>
    )}
  </>
);

export default LegacyFooter;
